module.exports = __webpack_public_path__ + "img/icon_ai_loading.abee996e.gif";